import script from "./jpVerifyModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./jpVerifyModal.vue?vue&type=script&lang=ts&setup=true"

import "./jpVerifyModal.vue?vue&type=style&index=0&id=114d80b6&scoped=true&lang=css"

import exportComponent from "/home/forge/tenant.mybcr.dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-114d80b6"]])

export default __exports__